module.exports = __webpack_public_path__ + "img/geofisica_4-3_3072.73c02a06.jpg";